import { TemplateRef } from '@angular/core';
import { IntelligenceModels } from '@models/intelligence.model';
import {
  CellTemplateContext,
  ColumnBuilder,
  crudActions,
  DatasetTableConfig,
  TableConfigBuilder,
} from '@ui/lib/ui-kit/ui-dataset-table';

type Tag = IntelligenceModels.Tags.Tag;

export type TagResultCellContext = CellTemplateContext<Tag>;

export interface CreateTagResultTableConfigDependencies {
  /** Name cell: the tag colour swatch followed by the tag name. */
  nameCellTemplate: TemplateRef<TagResultCellContext>;
  /** Left-panel cell: a checkmark or a cross for the `isShownInLeftPanel` flag. */
  isShownInLeftPanelCellTemplate: TemplateRef<TagResultCellContext>;
}

/**
 * Twin of the Database → Tags table: the same two columns and the same edit /
 * delete row actions. Rows stay non-clickable, because the page's row click
 * navigates to the tag's entities, which the Cmd+K panel does not render.
 */
export function createTagResultTableConfig(
  dependencies: CreateTagResultTableConfigDependencies,
): DatasetTableConfig<Tag> {
  const builder = new ColumnBuilder<Tag>();

  return new TableConfigBuilder<Tag>()
    .columns([
      builder
        .column('name')
        .label('DATABASE_TAGS.TABLE_NAME')
        .width('minmax(150px, 1fr)')
        .cellTemplate(dependencies.nameCellTemplate)
        .mobileVisible()
        .build(),

      builder
        .column('isShownInLeftPanel')
        .width('minmax(150px, 1fr)')
        .cellTemplate(dependencies.isShownInLeftPanelCellTemplate)
        .mobileVisible()
        .alignCenter()
        .headerWithTooltip('NAVIGATION_TREE.SHOW_IN_LEFT_PANEL', 'NAVIGATION_TREE.SHOW_IN_LEFT_PANEL_DESC')
        .build(),
    ])
    .actions(crudActions<Tag>())
    .trackBy('_id')
    .rowHeight(52)
    .build();
}
